import { useSites } from "api/sites";
import { UnlimitedPlanValue } from "enums/plans";
import { isEqual } from "helpers";
import { t } from "i18next";
import ApiKeyCard from "sites/ApiKeyCard";
import SiteCard from "sites/SiteCard";

export default function DashboardMenu() {
  const { data, isLoading } = useSites();

  return (
    <>
      <div className="card-div">
        <SiteCard
          isLoading={isLoading}
          sites={{
            description: t(
              isEqual(data?.site_details?.sites_limit, UnlimitedPlanValue)
                ? "sites.siteUsageDetail.unlimitedSites.body"
                : "sites.siteUsageDetail.body",
              {
                currentSites: data?.site_details?.total_used_site,
                totalSites: data?.site_details?.sites_limit,
                usagePercentage: Number(
                  data?.site_details?.site_percentage
                ).toFixed(2),
              }
            ),
            line: isEqual(data?.site_details?.sites_limit, UnlimitedPlanValue)
              ? 0
              : data?.site_details?.site_percentage,
          }}
          storage={{
            description: t(
              isEqual(data?.site_details?.sites_limit, UnlimitedPlanValue)
                ? "sites.storageUsageDetail.unlimitedStorage.body"
                : "sites.storageUsageDetail.body",
              {
                currentStorage: data?.storage_details?.total_used_storage,
                totalStorage: data?.storage_details?.storage_limit,
                usagePercentage: Number(
                  data?.storage_details?.storage_percentage
                ).toFixed(2),
              }
            ),
            line: isEqual(data?.site_details?.sites_limit, UnlimitedPlanValue)
              ? 0
              : data?.storage_details?.storage_percentage,
          }}
        />
      </div>
      <div className="card-div mt-3">
        <ApiKeyCard
          isLoading={isLoading}
          apikey={localStorage.getItem("apikey") ?? ""}
        />
      </div>
    </>
  );
}
